/**
 * Created By Elia Rohana on 12/2/18
 */

import {Action} from '@ngrx/store';
import {BpmnDeploymentIdentifier} from '@ispm-shared/modules/bpmn';
import {BpmnModelerData} from '@ispm-client/modules/bpmn-modeler/models/bpmn-modeler-data';
import {SaveParams} from '@ispm-client/modules/bpmn-modeler/models/save-params';

export enum BpmnProcessCreatorActionTypes {
    SAVE_BPMN = '[bpmn process creator] save bpmn',
    VALIDATE_BPMN = '[bpmn process creator] validate bpmn',
    PREVIEW_BPMN = '[bpmn process creator] preview bpmn',
    SAVE_BPMN_FAILURE = '[bpmn process creator] save bpmn failure',
    SAVE_BPMN_SUCCESS = '[bpmn process creator] save bpmn success',
    SAVE_BPMN_XML = '[bpmn process creator] save xml',
    SAVE_BPMN_XML_SUCCESS = '[bpmn process creator] save xml success',
    SAVE_BPMN_XML_FAILURE = '[bpmn process creator] save xml failure',
    GENERATE_BPMN_XML = '[bpmn process creator] generate xml',
    GENERATE_BPMN_XML_SUCCESS = '[bpmn process creator] generate xml success',
    GENERATE_BPMN_XML_FAILURE = '[bpmn process creator] generate xml failure',
    SET_BPMN_IDENTIFIER = '[bpmn process creator] set bpmn identifier'
}

export class SaveBpmn implements Action {
  readonly type = BpmnProcessCreatorActionTypes.SAVE_BPMN;
  constructor(public payload: SaveParams) { }
}

export class SaveBpmnSuccess implements Action {
  readonly type = BpmnProcessCreatorActionTypes.SAVE_BPMN_SUCCESS;
  constructor(public payload: { data: BpmnModelerData, onSuccess?: any }) { }
}
export class PreviewBpmn implements Action {
  readonly type = BpmnProcessCreatorActionTypes.PREVIEW_BPMN;

  constructor(public payload: BpmnModelerData) {
  }
}


export class ValidateBpmn implements Action {
  readonly type = BpmnProcessCreatorActionTypes.VALIDATE_BPMN;
  constructor(public payload){}

}

export class SaveBpmnXml implements Action {
    readonly type = BpmnProcessCreatorActionTypes.SAVE_BPMN_XML;
    constructor(public payload: { bpmnXml: string, onSuccess?: any }) { }
}

export class SaveBpmnXmlSuccess implements Action {
  readonly type = BpmnProcessCreatorActionTypes.SAVE_BPMN_XML_SUCCESS;
  constructor(public payload: { id: BpmnDeploymentIdentifier, onSuccess?: any }) { }
}

export class SaveBpmnXmlFailure implements Action {
    readonly type = BpmnProcessCreatorActionTypes.SAVE_BPMN_XML_FAILURE;
    constructor(public payload: { error: string }) { }
}

export class GenerateBpmnXml implements Action {
  readonly type = BpmnProcessCreatorActionTypes.GENERATE_BPMN_XML;
  constructor(public payload: { onSuccess?: any }) { }
}

export class GenerateBpmnXmlSuccess implements Action {
  readonly type = BpmnProcessCreatorActionTypes.GENERATE_BPMN_XML_SUCCESS;
  constructor(public payload: { bpmnXml: string, onSuccess?: any }) { }
}

export class GenerateBpmnXmlFailure implements Action {
  readonly type = BpmnProcessCreatorActionTypes.GENERATE_BPMN_XML_FAILURE;
  constructor(public payload: { error: string }) { }
}

export class SaveFailureAction implements Action {
    readonly type = BpmnProcessCreatorActionTypes.SAVE_BPMN_FAILURE;

    constructor(public payload: { error: string }) { }
}

export class SetBpmnIdentifier implements Action {
  readonly type = BpmnProcessCreatorActionTypes.SET_BPMN_IDENTIFIER;
  constructor(public payload: BpmnDeploymentIdentifier) { }
}

export type BpmnProcessActions = SaveBpmnXml | SaveBpmnXmlSuccess |  GenerateBpmnXml | GenerateBpmnXmlSuccess | SetBpmnIdentifier | ValidateBpmn | PreviewBpmn;
export type BpmnProcessErrorActions = GenerateBpmnXmlFailure | SaveBpmnXmlFailure;
export type BpmnSaveActions = SaveBpmn;
